<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let displayNum = 0;

    function interpolate(start, target, durationMS) {
        if (start === target) {
            return;
        }

        const steps = target - start;
        const frameDuration = durationMS / steps;
        const newStart = start + 1;

        displayNum = newStart;

        setTimeout(() => interpolate(newStart, target, durationMS - frameDuration), frameDuration);
    }

    let drawLine;
    let tl = gsap.timeline();
    let svgElement;

    onMount(() => {
        tl.fromTo(drawLine, {
            drawSVG: "100% 100%",
            transformOrigin: 'center center',
        }, {
            drawSVG: "100% 0%",
            stagger: 0.15,
            duration: 1,
            onStart: () => {
                interpolate(0, 61, 1000)
            },
        });

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 380 678" bind:this={svgElement}>
    <defs>
        <clipPath id="clip-path">
            <rect id="Rectangle_597" data-name="Rectangle 597" width="159.986" height="201.63" fill="none"/>
        </clipPath>
    </defs>
    <rect id="Rectangle_868" data-name="Rectangle 868" width="380" height="678"/>
    <text id="Top_three_content_essentials" data-name="Top three content essentials" transform="translate(40 51.446)"
          fill="#fcd0b1" font-size="24" font-family="Metric">
        <tspan x="0" y="0">Top three content essentials</tspan>
    </text>
    <text id="A_topic_that_addresses_the_board_agenda" data-name="A topic that addresses the board agenda"
          transform="translate(40 343)" fill="#fff" font-size="24" font-family="Metric">
        <tspan x="0" y="18">A topic that addresses</tspan>
        <tspan x="0" y="46">the board agenda</tspan>
    </text>
    <text id="_61_" data-name="61%" transform="translate(100 172)" fill="#fff" font-size="86"
          font-family="Metric-Bold, Metric" font-weight="700">
        <tspan x="27.171" y="66">{displayNum}%</tspan>
    </text>
    <g id="Group_1195" data-name="Group 1195" transform="translate(119 100.185)">
        <g id="Group_1194" data-name="Group 1194" clip-path="url(#clip-path)">
            <path bind:this={drawLine} id="Path_14607" data-name="Path 14607" d="M62.2,7.061A96.785,96.785,0,1,1,1,178.827" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14608" data-name="Path 14608" d="M56.958,6.6a5.4,5.4,0,1,1,5.4,5.4,5.4,5.4,0,0,1-5.4-5.4"
                  fill="#fff"/>
            <path id="Path_14609" data-name="Path 14609" d="M56.958,6.6a5.4,5.4,0,1,1,5.4,5.4A5.4,5.4,0,0,1,56.958,6.6Z"
                  fill="none" stroke="#100f0c" stroke-miterlimit="10" stroke-width="2.398"/>
        </g>
    </g>
</svg>
